import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle
} from "react";
import axios from "axios";
import API_BASE_URL from "../../../src/config";
import RevenueSubscriptionSection from "../revenue/RevenueSubscriptionSection";

const PoliciesSection = forwardRef(({ propStayId }, ref) => {

  const stayId = propStayId || localStorage.getItem("stayId");

  /* ---------------------------------------
     STATE
  ----------------------------------------*/
  const [checkinTime, setCheckinTime] = useState("");
  const [checkoutTime, setCheckoutTime] = useState("");
  const [noShowCutoffTime, setNoShowCutoffTime] = useState("");

  const [revenueModel, setRevenueModel] = useState("fixed");
  const [fixedPlan, setFixedPlan] = useState("999/1");
  const [commissionPercent, setCommissionPercent] = useState(15);

  const [cancellationPolicies, setCancellationPolicies] = useState([
    "Free cancellation up to 48 hours before check-in",
    "50% refund for cancellations made within 48 hours of check-in",
    "No refund for same-day cancellation or no-show",
    "Early departure is non-refundable",
    "Refunds will be processed within 7–10 business days"
  ]);

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  /* ---------------------------------------
     LOAD EXISTING DATA (EDIT MODE)
  ----------------------------------------*/
  useEffect(() => {
    if (!stayId) return;

    const token = localStorage.getItem("accessToken");

    axios.post(
      `${API_BASE_URL}stays/details`,
      { id: stayId },
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    )
      .then((res) => {
        const data = res.data.data;

        setCheckinTime(data.checkin || "12:00 pm");
        setCheckoutTime(data.checkout || "11:00 am");
        setNoShowCutoffTime(data.no_show_cutoff_time || "06:00 pm");

        if (data.cancellation_policy) {
          setCancellationPolicies(
            data.cancellation_policy.split(",")
          );
        }

        setRevenueModel(data.revenue_model || "fixed");
        setFixedPlan(data.fixed_plan || "999/1");
        setCommissionPercent(data.commission_percent || 15);
      })
      .catch((err) => {
        console.error("Failed to load policy data", err);
      });
  }, [stayId]);

  /* ---------------------------------------
     CANCELLATION POLICY HANDLERS
  ----------------------------------------*/
  const handlePolicyChange = (index, value) => {
    if (value.length > 150) return;

    const updated = [...cancellationPolicies];
    updated[index] = value;
    setCancellationPolicies(updated);
  };

  const addPolicyPoint = () => {
    setCancellationPolicies([...cancellationPolicies, ""]);
  };

  const removePolicyPoint = (index) => {
    setCancellationPolicies(
      cancellationPolicies.filter((_, i) => i !== index)
    );
  };

  /* ---------------------------------------
     SUBMIT (EXPOSED TO PARENT)
  ----------------------------------------*/
  useImperativeHandle(ref, () => ({
    submit: async () => {

      if (!stayId) {
        setMessage("Stay ID not found");
        return;
      }

      const validPolicies = cancellationPolicies.filter(
        (p) => p.trim().length >= 10
      );

      if (validPolicies.length === 0) {
        setMessage("Please add at least one valid cancellation policy");
        return;
      }

      if (
        revenueModel === "commission" &&
        (commissionPercent < 8 || commissionPercent > 20)
      ) {
        setMessage("Commission must be between 8% and 20%");
        return;
      }

      setLoading(true);
      setMessage("");

      try {
        const token = localStorage.getItem("accessToken");

        const payload = {
          stayId,
          checkin_time: checkinTime,
          checkout_time: checkoutTime,
          no_show_cutoff_time: noShowCutoffTime,
          cancellation_policy: validPolicies.join(","),
          revenue_model: revenueModel,
          fixed_plan: revenueModel === "fixed" ? fixedPlan : null,
          commission_percent:
            revenueModel === "commission" ? commissionPercent : null
        };

        const response = await axios.post(
          `${API_BASE_URL}stays/update-stay`,
          payload,
          {
            headers: { Authorization: `Bearer ${token}` }
          }
        );

        setMessage(
          response.data.success
            ? "Policies updated successfully"
            : response.data.message || "Update failed"
        );
      } catch (error) {
        console.error(error);
        setMessage("Server error while updating policies");
      } finally {
        setLoading(false);
      }
    }
  }));

  /* ---------------------------------------
     UI
  ----------------------------------------*/
  return (
    <div className="row">
      <div className="col-lg-8">

        <h3 className="mb-4">Policies</h3>

        {/* REVENUE MODEL */}
        {/* <div className="mb-4">
          <h5>Revenue Model</h5>

          <div className="form-check mt-2">
            <input
              type="radio"
              className="form-check-input"
              checked={revenueModel === "fixed"}
              onChange={() => setRevenueModel("fixed")}
            />
            <label className="form-check-label">
              Fixed Monthly Fee
            </label>
          </div>

          {revenueModel === "fixed" && (
            <select
              className="form-select mt-2"
              value={fixedPlan}
              onChange={(e) => setFixedPlan(e.target.value)}
            >
              <option value="999/1">₹999 / 1 Month</option>
            </select>
          )}

          <div className="form-check mt-3">
            <input
              type="radio"
              className="form-check-input"
              checked={revenueModel === "commission"}
              onChange={() => setRevenueModel("commission")}
            />
            <label className="form-check-label">
              Commission Based
            </label>
          </div>

          {revenueModel === "commission" && (
            <div className="mt-2">
              <input
                type="number"
                className="form-control"
                min="8"
                max="20"
                value={commissionPercent}
                onChange={(e) =>
                  setCommissionPercent(
                    parseInt(e.target.value || 0, 10)
                  )
                }
              />
              <small className="text-muted">
                Commission must be between 8% and 20%
              </small>
            </div>
          )}
        </div> */}

        {/* <div className="mb-4">
          <RevenueSubscriptionSection />
        </div> */}


        {/* CHECK-IN / CHECK-OUT */}
        <div className="row mb-4">
          <div className="col-md-6">
            <label>Check-in Time</label>
            <select
              className="form-select"
              value={checkinTime}
              onChange={(e) => setCheckinTime(e.target.value)}
            >
              <option value="10:00 am">10:00 am</option>
              <option value="11:00 am">11:00 am</option>
              <option value="12:00 pm">12:00 pm</option>
              <option value="01:00 pm">01:00 pm</option>
              <option value="02:00 pm">02:00 pm</option>
              <option value="03:00 pm">03:00 pm</option>
            </select>
          </div>

          <div className="col-md-6">
            <label>Check-out Time</label>
            <select
              className="form-select"
              value={checkoutTime}
              onChange={(e) => setCheckoutTime(e.target.value)}
            >
              <option value="09:00 am">09:00 am</option>
              <option value="10:00 am">10:00 am</option>
              <option value="11:00 am">11:00 am</option>
              <option value="12:00 pm">12:00 pm</option>
            </select>
          </div>

          <div className="col-md-6 mt-3">
            <label>No-Show Cutoff Time</label>
            <select
              className="form-select"
              value={noShowCutoffTime}
              onChange={(e) => setNoShowCutoffTime(e.target.value)}
            >
              <option value="04:00 pm">04:00 pm</option>
              <option value="05:00 pm">05:00 pm</option>
              <option value="06:00 pm">06:00 pm</option>
              <option value="07:00 pm">07:00 pm</option>
              <option value="08:00 pm">08:00 pm</option>
              <option value="09:00 pm">09:00 pm</option>
              <option value="10:00 pm">10:00 pm</option>
              <option value="11:00 pm">11:00 pm</option>
            </select>
            <small className="text-muted d-block mt-1">
              If a confirmed guest hasn't checked in by this time on their arrival date, the booking is automatically marked as a no-show and the room is released back to availability. No refund is given.
            </small>
          </div>
        </div>

        {/* HOUSE RULES & POLICIES */}
        <div className="mb-4">
          <label className="fw-bold">
            House Rules & Policies
          </label>
          <small className="text-muted d-block mb-2">
            Cancellation terms, house rules, or anything else guests should know before booking.
          </small>

          {cancellationPolicies.map((policy, index) => (
            <div className="mb-2" key={index}>
              <div className="d-flex">
                <input
                  type="text"
                  className="form-control"
                  placeholder="e.g. Free cancellation up to 48 hours before check-in, or No smoking indoors"
                  value={policy}
                  onChange={(e) =>
                    handlePolicyChange(index, e.target.value)
                  }
                />
                {cancellationPolicies.length > 1 && (
                  <button
                    type="button"
                    className="btn btn-outline-danger ms-2"
                    onClick={() => removePolicyPoint(index)}
                  >
                    ✕
                  </button>
                )}
              </div>
              <small className="text-muted">
                {policy.length}/150 characters
              </small>
            </div>
          ))}

          <button
            type="button"
            className="btn btn-outline-primary btn-sm mt-2"
            onClick={addPolicyPoint}
          >
            + Add another rule
          </button>
        </div>

        {message && (
          <div className="alert alert-info">{message}</div>
        )}

        {loading && <p>Saving...</p>}

      </div>
    </div>
  );
});

export default PoliciesSection;
